import axios from "axios";
import { API_URL } from "../utils/constant";
import { FETCH_CVE_DETAILS, FETCH_TOTAL_RISK_FINDING, FETCH_CVE_DETAILS_GRAPH , FETCH_CVE_DETAILS_TOTAL } from "./index";
import { toastr } from "react-redux-toastr";

export const fetchCVEDetails = (props, dispatch, page, pageSize, search , category, ipFilter, limit, cveId ) => {
  if (props) {
    const session = localStorage.getItem("session");
    axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;

    let url = `${API_URL}/cve-details/${props}/delta?page=${page}&limit=${limit}&severity=${search}&category=${category}&ip=${ipFilter}&cveId=${cveId}`;
    axios
      .get(
        url
      )
      .then((response) => {
        dispatch({
          type: FETCH_CVE_DETAILS,
          payload: response.data,
        });
      })
      .catch((err) => {
        var message = "Some server error has occurred.";
        if (err.response) {
          message = err.response.data.userMessage;
        }
        dispatch({
          type: FETCH_CVE_DETAILS,
          payload: { error: true, userMessage: message },
        });
      });
  }
};

export const fetchActiveCVEDetails = (props, dispatch, page, search, searchName, category, limit) => {
  if (props) {
    const session = localStorage.getItem("session");
    axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;
    axios
      .get(
        `${API_URL}/organisations/${props}/active-vulnerabilities/scan/findings?risk=${search}&page=${page}&limit=${limit}&search=${searchName}&category=${category}`
      )
      .then((response) => {
        dispatch({
          type: FETCH_CVE_DETAILS,
          payload: response.data,
        });
      })
      .catch((err) => {
        var message = "Some server error has occurred.";
        if (err.response) {
          message = err.response.data.userMessage;
        }
        dispatch({
          type: FETCH_CVE_DETAILS,
          payload: { error: true, userMessage: message },
        });
      });
  }
};

export const fetchRiskTotalFinding = (props, dispatch, page, searchName, sortOrder,risk) => {
  if (props) {
    const session = localStorage.getItem("session");
    axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;
    axios
      .get(
        `${API_URL}/organisations/${props}/active-vulnerabilities/scan/totalRiskFindings?risk=${risk}&page=${page}&ipAddress=${searchName}&sortOrder=${sortOrder}`
      )
      .then((response) => {
        dispatch({
          type: FETCH_TOTAL_RISK_FINDING,
          payload: response.data,
        });
      })
      .catch((err) => {
        var message = "Some server error has occurred.";
        if (err.response) {
          message = err.response.data.userMessage;
        }
        dispatch({
          type: FETCH_CVE_DETAILS,
          payload: { error: true, userMessage: message },
        });
      });
  }
};

export const fetchActiveCVEDetailsAction = (props, dispatch, search, page, searchName, category, data) => {

  if (props) {
    const session = localStorage.getItem("session");
    axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;

    axios
      .post(
        `${API_URL}/organisations/${props}/active-vulnerabilities/action?risk=${search}&page=${page}&search=${searchName}&category=${category}`,data
      )
      .then((response) => {
        dispatch({
          type: FETCH_CVE_DETAILS,
          payload: response.data,
        });
        if (response.data.status === 200) {
          toastr.success("Success", response.data.userMessage);
        } else {
          toastr.success("Error", response.data.userMessage);
        }
      })
      .catch((err) => {
        var message = "Some server error has occurred.";
        if (err.response) {
          message = err.response.data.userMessage;
        }
        dispatch({
          type: FETCH_CVE_DETAILS,
          payload: { error: true, userMessage: message },
        });
      });
  }
};

export const addIpVa = (props, dispatch,data) => {
  const session = localStorage.getItem("session");
  axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;
  if (props) {
    axios
      .post(`${API_URL}/organisations/${props}/active-vulnerabilities/scan`,data)
      .then((res) => {
        if (res.data.error === false) {
          fetchRiskTotalFinding(props,dispatch,1,'','')
          toastr.success("Success", res.data.message);
        } else {
          toastr.error("Error", res.data.message);
        }
      })
      .catch((err) => {
        var message = "Some server error has occurred.";
        if (err.res) {
          message = err.res.data.message;
        }
      });
  }
};

export const fetchActiveFindingCVEDetails = (props, dispatch, page, pageSize, search , category, ipFilter, finding) => {

  if (props) {
    const session = localStorage.getItem("session");
    axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;

    axios
      .get(
        `${API_URL}/organisations/${props}/active-vulnerabilities/scan/findings/${finding}?risk=${search}&page=${page}`
      )
      .then((response) => {
        dispatch({
          type: FETCH_CVE_DETAILS,
          payload: response.data,
        });
      })
      .catch((err) => {
        var message = "Some server error has occurred.";
        if (err.response) {
          message = err.response.data.userMessage;
        }
        dispatch({
          type: FETCH_CVE_DETAILS,
          payload: { error: true, userMessage: message },
        });
      });
  }
};

export const fetchCVEDetailsAction = (props, dispatch, page, pageSize, search , category , ipFilter, data, cveId = "") => {
  // const cookie = new Cookies();
  // const session = cookie.get("session");
  if (props) {
    const session = localStorage.getItem("session");
    axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;

    let actionUrl = `${API_URL}/cve-details/${props}/action?page=${page}&limit=${pageSize}&severity=${search}&category=${category}&ip=${ipFilter}`;
    if (cveId) {
      actionUrl += `&cveId=${encodeURIComponent(cveId)}`;
    }
    axios
      .post(
        actionUrl,data
      )
      .then((response) => {
        // dispatch({
        //   type: FETCH_CVE_DETAILS,
        //   payload: response.data,
        // });
        if(response.data.status === 200){
          toastr.success("Success", response.data.userMessage);
          fetchCVEDetails(props, dispatch, page, pageSize, search , category, ipFilter, 10, cveId);
          fetchCVEDetailsTotal(props, dispatch);
          fetchCVEDetailsGraph(props, dispatch);
        }else{
          toastr.error("Error", response.data.userMessage);
        }
      })
      .catch((err) => {
        var message = "Some server error has occurred.";
        if (err.response) {
          message = err.response.data.userMessage;
        }
        dispatch({
          type: FETCH_CVE_DETAILS,
          payload: { error: true, userMessage: message },
        });
      });
  }
};

export const fetchCVEDetailsGraph = (props, dispatch) => {
  // const cookie = new Cookies();
  // const session = cookie.get("session");
  if (props) {
    const session = localStorage.getItem("session");
    axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;

    axios
      .get(
        `${API_URL}/cve-details/${props}/graph`
      )
      .then((response) => {
        dispatch({
          type: FETCH_CVE_DETAILS_GRAPH,
          payload: response.data,
        });
      })
      .catch((err) => {
        var message = "Some server error has occurred.";
        if (err.response) {
          message = err.response.data.userMessage;
        }
        dispatch({
          type: FETCH_CVE_DETAILS_GRAPH,
          payload: { error: true, userMessage: message },
        });
      });
  }
};

export const fetchCVEDetailsTotal = (props, dispatch) => {
  // const cookie = new Cookies();
  // const session = cookie.get("session");
  if (props) {
    const session = localStorage.getItem("session");
    axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;

    axios
      .get(
        `${API_URL}/cve-details/${props}/totals`
      )
      .then((response) => {
        dispatch({
          type: FETCH_CVE_DETAILS_TOTAL,
          payload: response.data,
        });
      })
      .catch((err) => {
        var message = "Some server error has occurred.";
        if (err.response) {
          message = err.response.data.userMessage;
        }
        dispatch({
          type: FETCH_CVE_DETAILS_TOTAL,
          payload: { error: true, userMessage: message },
        });
      });
  }
};

export const fetchActiveCVEDetailsTotal = (props, dispatch) => {
  // const cookie = new Cookies();
  // const session = cookie.get("session");
  if (props) {
    const session = localStorage.getItem("session");
    axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;

    axios
      .get(
        `${API_URL}/organisations/${props}/active-vulnerabilities/scan/totals`
      )
      .then((response) => {
        dispatch({
          type: FETCH_CVE_DETAILS_TOTAL,
          payload: response.data,
        });
      })
      .catch((err) => {
        var message = "Some server error has occurred.";
        if (err.response) {
          message = err.response.data.userMessage;
        }
        dispatch({
          type: FETCH_CVE_DETAILS_TOTAL,
          payload: { error: true, userMessage: message },
        });
      });
  }
};


export const fetchMasterScan = (orgId, type, dispatch) => {
  // const cookie = new Cookies();
  // const session = cookie.get("session");
  const session = localStorage.getItem("session");
  axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;

  axios
    .get(`${API_URL}/organisations/${orgId}/active-vulnerabilities/scan/findings`)
    .then((response) => {
      dispatch({
        type: "MASTER_SCAN",
        payload: response.data,
      });
    })
    .catch((err) => {
      var message = "Some server error has occurred.";
      if (err.response) {
        message = err.response.data.userMessage;
      }
      dispatch({
        type: "MASTER_SCAN",
        payload: { error: true, userMessage: message },
      });
    });
};

export const getMasterScanData = (props, orgId, dispatch) => {
  // const cookie = new Cookies();
  // const session = cookie.get("session");
  if (props && props !== "") {
    const session = localStorage.getItem("session");
    axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;

    axios
      .get(`${API_URL}/getMasterScans/${props}/${orgId}`)
      .then((response) => {
        dispatch({
          type: "MASTER_SCAN_DETAILS",
          payload: response.data,
        });
      })
      .catch((err) => {
        var message = "Some server error has occurred.";
        if (err.response) {
          message = err.response.data.userMessage;
        }
        dispatch({
          type: "MASTER_SCAN_DETAILS",
          payload: { error: true, userMessage: message },
        });
      });
  }
};